import React, { ComponentProps } from "react";
import formatAsCurrency from "@wss/utilities/formatAsCurrency";
import { cls } from "cls";

/**
 * These components are use for price presentation. DO NOT ADD LOGIC if it is not an explicit
 * responsibility of pricing presentation.
 */

export interface PriceProps extends ComponentProps<"span"> {
  price: number;
}

const Price = ({ price, className, ...rest }: PriceProps) => (
  <span className={cls("font-bold text-red-500", className)} {...rest}>
    {formatAsCurrency.formatIfUndefined(price)}
  </span>
);

export default Price;
